import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'delayHours',
    standalone: false
})
export class DelayHoursPipe implements PipeTransform {
  transform(value: number, hourText: string): string | number {
    return value ? (value > 0 ? `+${value} ${hourText}` : `${value} ${hourText}`) : value;
  }
}
